import * as React from 'react';
import { IBac } from '../../models';
import styles from './DepotsView.module.scss';

export interface IBacEditorModalProps {
  bac: IBac;
  onSave: (updates: Partial<IBac>) => Promise<void>;
  onCancel: () => void;
}

export const BacEditorModal: React.FC<IBacEditorModalProps> = ({ bac, onSave, onCancel }) => {
  const [draft, setDraft] = React.useState<IBac>({ ...bac });
  const [saving, setSaving] = React.useState(false);

  const handleSave = async (): Promise<void> => {
    setSaving(true);
    try {
      const updates: Partial<IBac> = {
        Title: draft.Title,
        VolumeUtile: Number(draft.VolumeUtile) || 0,
        RestrictionClients: draft.RestrictionClients,
        PointDepot: draft.PointDepot,
        DetailsDepot: draft.DetailsDepot,
        InfoClients: draft.InfoClients,
        DetailsClients: draft.DetailsClients,
        Commentaire: draft.Commentaire,
      };
      await onSave(updates);
    } catch (e) {
      alert('Erreur : ' + (e as Error).message);
      setSaving(false);
    }
  };

  const handleRestrictionChange = (raw: string): void => {
    const trimmed = raw.trim();
    if (trimmed === '') {
      setDraft({ ...draft, RestrictionClients: null });
      return;
    }
    const pct = parseFloat(trimmed.replace(',', '.'));
    if (isNaN(pct)) return;
    setDraft({ ...draft, RestrictionClients: pct / 100 });
  };

  return (
    <div className={styles.modalOverlay} onClick={onCancel}>
      <div className={styles.modal} onClick={e => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h3>Modifier le bac <span className={styles.modalBacId}>{bac.Title}</span></h3>
          <button className={styles.modalClose} onClick={onCancel}>×</button>
        </div>

        <div className={styles.modalBody}>
          <div className={styles.formRow}>
            <label className={styles.formLabel}>
              Identifiant
              <input
                className={styles.formInput}
                value={draft.Title}
                onChange={e => setDraft({ ...draft, Title: e.target.value })}
              />
            </label>
            <label className={styles.formLabel}>
              Volume utile (m³)
              <input
                className={styles.formInput}
                type="number"
                value={draft.VolumeUtile || ''}
                onChange={e => setDraft({ ...draft, VolumeUtile: Number(e.target.value) })}
              />
            </label>
            <label className={styles.formLabel}>
              Restriction clients (%)
              <input
                className={styles.formInput}
                type="text"
                placeholder="ex: -30"
                value={draft.RestrictionClients != null ? (draft.RestrictionClients * 100).toFixed(0) : ''}
                onChange={e => handleRestrictionChange(e.target.value)}
              />
            </label>
          </div>

          <div className={styles.formRow}>
            <label className={styles.formCheck}>
              <input
                type="checkbox"
                checked={draft.PointDepot}
                onChange={e => setDraft({ ...draft, PointDepot: e.target.checked })}
              />
              <span>Point fait avec le dépôt</span>
            </label>
            <label className={styles.formCheck}>
              <input
                type="checkbox"
                checked={draft.InfoClients}
                onChange={e => setDraft({ ...draft, InfoClients: e.target.checked })}
              />
              <span>Info transmise aux clients</span>
            </label>
          </div>

          <label className={styles.formLabel}>
            Détails dépôt / ST / HSE
            <textarea
              className={styles.formTextarea}
              rows={3}
              value={draft.DetailsDepot}
              onChange={e => setDraft({ ...draft, DetailsDepot: e.target.value })}
            />
          </label>

          <label className={styles.formLabel}>
            Détails clients
            <textarea
              className={styles.formTextarea}
              rows={3}
              value={draft.DetailsClients}
              onChange={e => setDraft({ ...draft, DetailsClients: e.target.value })}
            />
          </label>

          <label className={styles.formLabel}>
            Commentaire
            <textarea
              className={styles.formTextarea}
              rows={2}
              value={draft.Commentaire}
              onChange={e => setDraft({ ...draft, Commentaire: e.target.value })}
            />
          </label>
        </div>

        <div className={styles.modalFooter}>
          <button className={styles.btnGhost} onClick={onCancel} disabled={saving}>
            Annuler
          </button>
          <button className={styles.btnPrimary} onClick={handleSave} disabled={saving}>
            {saving ? 'Sauvegarde…' : 'Enregistrer'}
          </button>
        </div>
      </div>
    </div>
  );
};
